<template>
  <img v-if="props.iso === 'zhTW'"
       src="@/asset/img/core/img-background.png"
       alt="avatar"
       :width="props.size"
       :height="props.size"
       :style="{
          backgroundImage: `url(${ zhTW })`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain'}" />
  <img v-else-if="props.iso === 'zhCN'"
       src="@/asset/img/core/img-background.png"
       alt="avatar"
       :width="props.size"
       :height="props.size"
       :style="{
          backgroundImage: `url(${ zhCN })`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain'}" />
</template>

<script setup>

import zhTW from '@/asset/img/flag/zh_TW.png'
import zhCN from '@/asset/img/flag/zh_CN.png'

const props = defineProps({
    iso: { type: String, required: true },
    size: { type: Number, required: false, default: 28 }
  })

</script>

<style scoped>

</style>
